import { PaletteOptions, PaletteMode } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unityPrimitiveColorTokens } from '../unityTokens';
import { blue, green } from './colors';

export const illustration = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['illustration'] => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          blue1: unityPrimitiveColorTokens['--color-blue-100'],
          blue2: unityPrimitiveColorTokens['--color-blue-300'],
          green1: unityPrimitiveColorTokens['--color-green-100'],
          green2: unityPrimitiveColorTokens['--color-green-400'],
        }
      : {
          blue1: unityPrimitiveColorTokens['--color-blue-900'],
          blue2: unityPrimitiveColorTokens['--color-blue-800'],
          green1: unityPrimitiveColorTokens['--color-green-900'],
          green2: unityPrimitiveColorTokens['--color-green-700'],
        };
  }
  return mode === 'light'
    ? {
        blue1: blue[100],
        blue2: blue[200],
        green1: green[100],
        green2: green[300],
      }
    : {
        blue1: blue[800],
        blue2: blue[700],
        green1: green[800],
        green2: green[600],
      };
};
